import { FC, ReactNode } from 'react';
import styled from 'styled-components';

interface WrapperProps {
    isDisabled: boolean;
}
const StWrapper = styled.div<WrapperProps>`
    opacity: ${({ isDisabled }) => (isDisabled ? 0.3 : 1)};
`;

interface Props {
    isDisabled: boolean;
    children: ReactNode;
    className?: string;
}

const DisableWrapper: FC<Props> = ({ children, isDisabled, className }) => {
    return (
        <StWrapper className={className} isDisabled={isDisabled}>
            {children}
        </StWrapper>
    );
};

export { DisableWrapper };
